module.exports = __webpack_public_path__ + "img/incorporacao_imobiliaria-1024x512.482d7b5d.jpg";